import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getContactsReducer = (state: RootState) => state.contactsReducer;

export const fullReducer = createSelector(getContactsReducer, (res) => res);
export const advancedFilters = createSelector(getContactsReducer, (res) => res.pageContext.filters.advanced);
export const pageContext = createSelector(getContactsReducer, (res) => res.pageContext);
